import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=6ac75f3a&"
import script from "./FooterHome.vue?vue&type=script&lang=js&"
export * from "./FooterHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports